import { connect } from 'react-redux'
import Header from './Header'

import onClickEdit from './Handlers/onClickEdit'
import onClickDelete from './Handlers/onClickDelete'

const mapStateToProps = (state) => ({
  subInvoice: state.screens.SubInvoice.subInvoice,
})

const actionCreators = {
  onClickEdit,
  onClickDelete,
}

export default connect(mapStateToProps, actionCreators)(Header)
